module.exports = __webpack_public_path__ + "img/Intuitive_Planet_logo-sideBYside-AllWhite.8b40a455.svg";